export default "__VITE_ASSET__89534a81__"